import { Directive, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Role } from "./roles";
import { UserRoleService } from "./user-role-service";

@Directive({selector: "[enabledForRoles]"})
export class EnabledForRolesDirective implements OnInit {
    constructor(private userRoleService: UserRoleService) {
    }

    @Input() public allowedRoles: Role[];
    @Input() public formGroup: FormGroup;

    ngOnInit() {
        if (!this.userRoleService.hasRoles(this.allowedRoles)) {
            this.formGroup.disable();
        }
    }
}
